import { useDispatch, useSelector } from "react-redux";

import actions from "@/actions";
import { Button, Modal, Tabs } from "@/components";
import MessageDisplay from "@/components/core/layout/MessageDisplay";

import tabs from "./tabs";

/**
 * Modal dialog for advanced map operations such as bulk import and bulk shift.
 *
 * @returns The rendered advanced operations modal.
 */
const AdvancedOperations = () => {
    const visible = useSelector(
        ({ topBar }) => topBar.advancedOperationsVisibility,
    );
    const dispatch = useDispatch();

    const onClose = () => {
        dispatch(actions.topBar.setAdvancedOperationsVisibility(false));
        dispatch(actions.window.hideMessage("advanced-operations"));
    };

    return (
        <Modal
            title={"Advanced Operations"}
            className="advanced-operations"
            visible={visible}
            onClose={onClose}
            footer={
                <Button outlined onClick={onClose}>
                    {"Close Advanced Operations"}
                </Button>
            }
            slotProps={{
                paper: {
                    sx: {
                        height: "30rem",
                    },
                },
            }}
        >
            <MessageDisplay context={"advanced-operations"} />
            <Tabs className="react-tabs">{tabs}</Tabs>
        </Modal>
    );
};

export default AdvancedOperations;
